var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.79883,44.20117a27.9983,27.9983,0,0,0-42.221,36.56445l-88.8125,88.8125a28.03763,28.03763,0,0,0-36.56421,2.623h-.00049a28.00012,28.00012,0,1,0,42.2212,3.03369l88.81274-88.813a27.99812,27.99812,0,0,0,36.56421-42.22071ZM78.14258,206.14258a20.00046,20.00046,0,1,1-28.28467-28.28516h-.00049a20.00063,20.00063,0,0,1,28.28516,28.28516Zm128-128a20.02563,20.02563,0,0,1-28.2832.002l-.00147-.002a20.00028,20.00028,0,1,1,28.28467,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSegment);
export default __webpack_public_path__ + "static/media/line-segment.4563674d8c5470504f0c7d8e26e53667.svg";
export { ForwardRef as ReactComponent };